import ContentSection from './components/ContentSection';
import { TermsAndConditionsWrapper } from './styles';

const TermsAndConditions = () => {
  return (
    <TermsAndConditionsWrapper>
      <ContentSection />
    </TermsAndConditionsWrapper>
  );
};

export default TermsAndConditions;
